/**
 * One number for "how loud is this right now", from an analyser's time-domain bytes.
 *
 * Bytes sit around 128 at silence; the RMS of their deviation is the honest energy of the signal.
 * The square root at the end is perceptual, not decorative: speech RMS lives low in the range, and
 * without it the mark would barely move for a voice that is clearly speaking.
 */
export function levelFromTimeDomain(samples: Uint8Array): number {
  if (samples.length === 0) return 0;
  let sum = 0;
  for (const value of samples) {
    const deviation = (value - 128) / 128;
    sum += deviation * deviation;
  }
  const rms = Math.sqrt(sum / samples.length);
  return Math.min(1, Math.sqrt(rms) * 1.6);
}
